module.exports = "/assets/data/934f8fef08e5d85a9625edea8f3cd718-SA67.data.json";